module.exports = __webpack_public_path__ + "img/round-members-24px.6e0b5167.png";